import React from 'react';
import InlineMenu from '../../../02-molecules/menus/InlineMenu/InlineMenu.component';
import SocialMenu from '../../../02-molecules/menus/SocialMenu/SocialMenu.component';
import { menuItemPropType } from '../../../02-molecules/menus/MenuItem.component';
import bem from '../../../_utils/bem';

var SiteFooter = function SiteFooter(_ref) {
  var items = _ref.items;
  var block = 'footer';
  return /*#__PURE__*/React.createElement("footer", {
    className: bem(block)
  }, /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'inner')
  }, /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'social')
  }, /*#__PURE__*/React.createElement(SocialMenu, null)), /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'menu')
  }, /*#__PURE__*/React.createElement(InlineMenu, {
    items: items
  }))));
};

export default SiteFooter;